import * as yup from "yup";

export type FormValues = {
  promocode: string;
};

export const validationSchema = yup.object({
  promocode: yup.string().required("Вкажіть 'Промокод'"),
});
